"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BonusTournamentsGamesList_1 = require("./BonusTournamentsGamesList");
var BonusTournamentsGamesEditor_1 = require("./BonusTournamentsGamesEditor");
var BonusTournamentGames = /** @class */ (function (_super) {
    __extends(BonusTournamentGames, _super);
    function BonusTournamentGames(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentGames.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_GG = this.props.listGameSetGames.Subscribe("*", function (id, data) {
            _this.setState({ availGames: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availGames: []
        }, function () {
            _this.props.listGameSetGames.LoadDataByTournamentId(_this.props.record.key);
        });
        this.props.state.setExtBreadCrumbPath(["Турниры", "Игры турниров"]);
    };
    BonusTournamentGames.prototype.componentWillUnmount = function () {
        this.props.listGameSetGames.UnSubscribe(this.SID_GG);
    };
    BonusTournamentGames.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BonusTournamentGames.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    BonusTournamentGames.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    BonusTournamentGames.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    BonusTournamentGames.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTournamentsGamesEditor_1.default, { state: this.props.state, data: this.props.dataGames, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availGames: this.state.availGames, record: null }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTournamentsGamesEditor_1.default, { state: this.props.state, data: this.props.dataGames, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availGames: this.state.availGames, record: this.state.record }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTournamentsGamesList_1.default, { state: this.props.state, data: this.props.dataGames, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    BonusTournamentGames.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return BonusTournamentGames;
}(React.Component));
exports.default = BonusTournamentGames;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/games/BonusTournamentsGames.tsx
// module id = 2511
// module chunks = 0